import { render } from "./ProdottoDetail.vue?vue&type=template&id=771d455c&scoped=true"
import script from "./ProdottoDetail.vue?vue&type=script&lang=js"
export * from "./ProdottoDetail.vue?vue&type=script&lang=js"

import "./ProdottoDetail.vue?vue&type=style&index=0&id=771d455c&scoped=true&lang=css"

import exportComponent from "/var/www/html/levante_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-771d455c"]])

export default __exports__